export default{
    documents:[],
    vouchersType:[],
    categories:[],
    category:{
        id:'',
    },

params:{
    voucherType:'',
    branch:'',
    date:''
}
}



// WEBPACK FOOTER //
// ./src/modules/documents/state.js